import IconViewProduct from '../asserts/icon/view-product.png'

import ImageProductTitleBackground from '../asserts/product/title-background.png'
import ImageProductTab1 from '../asserts/product/tab1.png'
import ImageProductTab2 from '../asserts/product/tab2.png'
import ImageProductTab3 from '../asserts/product/tab3.png'
import ImageProductT1P1Img1 from '../asserts/product/t1-p1-img1.png'
import ImageProductT1P1Img2 from '../asserts/product/t1-p1-img2.png'
import ImageProductT1P1Img3 from '../asserts/product/t1-p1-img3.png'
import ImageProductT1P1Img4 from '../asserts/product/t1-p1-img4.png'
import ImageProductT1P1Img5 from '../asserts/product/t1-p1-img5.png'
import ImageProductT1P2Img1 from '../asserts/product/t1-p2-img1.png'
import ImageProductT1P3Img1 from '../asserts/product/t1-p3-img1.png'
import ImageProductT1P3Img2 from '../asserts/product/t1-p3-img2.png'
import ImageProductT1P3Img3 from '../asserts/product/t1-p3-img3.png'
import ImageProductT1P3Img4 from '../asserts/product/t1-p3-img4.png'
import ImageProductT2P1Img1 from '../asserts/product/t2-p1-img1.png'
import ImageProductT2P2Img1 from '../asserts/product/t2-p2-img1.png'
import ImageProductT2P3Img1 from '../asserts/product/t2-p3-img1.png'
import ImageProductT2P4Img1 from '../asserts/product/t2-p4-img1.png'
import ImageProductT3P1Img1 from '../asserts/product/t3-p1-img1.png'
import ImageProductT3P2Img1 from '../asserts/product/t3-p2-img1.png'
import ImageProductT3P3Img1 from '../asserts/product/t3-p3-img1.png'

import VideoProdcutT1P1V1 from '../asserts/product/t1-p1-v1.mp4'

const PRODUCTCONFIG = {
  title: { en: 'Product display', cn: '产品展示', background: ImageProductTitleBackground },
  introduction: {
    en: 'Jumin Bio-technologies Co., Ltd promotes technological innovation ,improves the technical content of products and invests to improve purification system and the industrial automatic system, which takes the lead in China to automatically pour, print, assemble, pack and sterilize with computer, it improves labor productivity and health condition. Addition, the company is the first to use the technology of paper-compound color packs, which reduces EO remnant, enhances product quality and effectively prevent counterfeiting problem.',
    cn: '聚民生物科技有限公司推进科技技术创新，提高产品技术含量并投产改造净化系统和工业化系统，在国内领先实现自动化注塑、印刷、装配、包装和电脑化灭菌，大大提高生产率及卫生条件，并首家使用注射器、输液器纸塑复合彩色包装技术，减少环氧乙烷气体残留量，即提高产品品质，又避免了产品假冒。'
  },
  info: [
    {
      title: { en: 'Syringe', cn: '注射器类' },
      image: ImageProductTab1,
      icon: IconViewProduct,
      content: [
        {
          name: { en: 'Single-use Disposable Safety Syringe', cn: '一次性使用无菌自毁式注射器' },
          introduction: [
            { en: 'US GB15810、GB15811 Compliant', cn: 'US GB15810、GB15811标准' },
            { en: 'One hand use, with automatic needle retraction into plunger/barrel after injection.', cn: '可单手使用，注射后针尖自动回缩到芯杆' },
            { en: 'Once retracted, the needle is sealed inside the syringe, to ensure medical safety.', cn: '回缩后，针尖封在芯杆里，保证医疗安全' },
            { en: 'The simple design using a unique double safety retraction mechanism makes the product the first choice for hospital use and immunization programs.', cn: '简单的双重安全结构使产品成为医院和免疫项目的首选' },
            { en: 'Available in 1ml、2ml、3ml、5ml、10ml.', cn: '不同的规格1ml、2ml、3ml、5ml、10ml' }
          ],
          images: [
            { type: 'video', src: VideoProdcutT1P1V1 },
            { type: 'image', src: ImageProductT1P1Img1 },
            { type: 'image', src: ImageProductT1P1Img2 },
            { type: 'image', src: ImageProductT1P1Img3 },
            { type: 'image', src: ImageProductT1P1Img4 }
          ],
          detail: [
            { type: 'image', src: ImageProductT1P1Img5 }
          ]
        },
        {
          name: { en: 'Single-use Disposable Safety Syringe', cn: '一次性使用无菌注射器' },
          introduction: [
            { en: 'Abide by the standard of GB15810-2001.', cn: '执行GB15810-2001标准' },
            { en: 'This particular safety syringe design structure is acceptable in many markets.The product is easy to use and operate.', cn: '结构合理，易操作，安全可靠' },
            { en: 'The product is sterile and has no pyrogen or hemolysis reaction.', cn: '无菌，无毒，无热源，无溶血作用' },
            { en: 'The transparent clarity of the barrel is easy to visualize the proper dosage of medication.', cn: '外套透明度高，便于观察药液' },
            { en: 'The sharpness of the needle can minimize patient discomfort during injection.', cn: '针尖锋利，减轻疼感' },
            { en: 'The product has good sliding and sealing properties.', cn: '良好滑动性和密封性' },
            { en: 'Once used, the plunger can be broken off, which guarantees single use.', cn: '芯感使用后可折断，保证单次使用。' }
          ],
          images: [
            { type: 'image', src: ImageProductT1P2Img1 }
          ]
        },
        {
          name: { en: 'Others', cn: '其他类' },
          introduction: [
            { en: 'Safety Injection Needle', cn: '安全式注射针' },
            { en: 'Blunt Against Puncture Syringe', cn: '钝头防刺伤注射器' },
            { en: 'Single Use Irrigation Syringe', cn: '一次性使用冲洗器' },
            { en: 'Irrigation Syringe with Bag', cn: '带瓶冲洗器' }
          ],
          images: [
            { type: 'image', src: ImageProductT1P3Img1 },
            { type: 'image', src: ImageProductT1P3Img2 },
            { type: 'image', src: ImageProductT1P3Img3 },
            { type: 'image', src: ImageProductT1P3Img4 }
          ]
        }
      ]
    },
    {
      title: { en: 'Infusion Set', cn: '输液器类' },
      image: ImageProductTab2,
      icon: IconViewProduct,
      content: [
        {
          name: { en: 'Single-use Sterile Infusion Set', cn: '一次性使用输液器' },
          introduction: [
            { en: 'Europe CE compliance.', cn: '欧洲CE标准' },
            { en: 'Made of high quality medical approved materials, and sterilized with EO.', cn: '采用医用高分子材料制造，环氧乙烷气体灭菌' },
            { en: 'Aseptic, no pyrogen and hemolysis reaction.', cn: '无菌、无毒、无热原、无溶血作用' },
            { en: 'Safe, reliable and recognized as first choice of hospital.', cn: '安全可靠，医院首选' },
            { en: 'Tube is made of PVC/PP, which is anti-kink.', cn: '导管采用弹性PVC/PP，可以防止纠结' },
            { en: 'Air filter can prevent bacteria and dust from entering inside.', cn: '输液器配有空气过滤膜，阻止细菌、尘埃进入输液器内' },
            { en: 'Medication filter can scan 15-25μm particles in the solution to secure the safe of transfusion.', cn: '同时配有药液过滤膜，可过滤药液中15-25μm的不溶性微粒，确保输液安全可靠' }
          ],
          images: [
            { type: 'image', src: ImageProductT2P1Img1 }
          ]
        },
        {
          name: { en: 'One-time Precision Filtration Infusion Set（TPE Material）', cn: '一次性使用精密过滤输液器（TPE材料）' },
          introduction: [
            { en: 'One-time use of precision filter infusion device', cn: '一次性使用精密过滤输液器' },
            { en: 'Precision filter media are 2,3 and 5 microns', cn: '精密过滤介质2μm、3μm、5μm' },
            { en: 'It is suitable for clinical intravenous infusion', cn: '适用于临床人体静脉输液药液' },
            { en: 'Non-PVC, no plasticizer DEHP, automatic liquid stop', cn: '非PVC，不含增塑剂DEHP,自动止液' },
            { en: 'It can be applied to people who are not suitable to use PVC infusion device', cn: '可适用于不宜使用PVC输液器的人群' },
            { en: 'It can be applied to drugs that easily dissolve plasticizer from PVC', cn: '可适用于易使PVC中增塑剂溶出的药物' },
            { en: 'It can be applied to drugs easily adsorbed by PVC', cn: '可适用于容易被PVC吸附的药物' },
            { en: 'No oil plasticizer was added', cn: '不添加油类增塑剂' },
            { en: 'Automatic liquid stop', cn: '自动止液' },
            { en: 'Precision filtration', cn: '精密过滤' },
            { en: 'More environmentally friendly', cn: '更加环保' }
          ],
          images: [{ type: 'image', src: ImageProductT2P2Img1 }]
        },
        {
          name: { en: 'One-time Precision Filtration Infusion Set', cn: '一次性使用精密过滤输液器' },
          introduction: [
            { en: 'One-time use of precision filter infusion device with needle', cn: '一次性使用精密过滤输液器带针' },
            { en: 'Bottle stopper puncture device, drop pot, catheter, regulator ,precision filter, medication（injection）parts, venipuncture needle、sheath', cn: '瓶塞穿刺器、滴壶、导管、调节器、精密过滤器、加药（注射）件、静脉穿刺针、护套' },
            { en: 'Precision filters can remove particles above 0.5-5.0 micron（micron)in liquid medicine more than 90%,and air filters can remove particles above 0.5micron（micron)in air more than 90%.', cn: '精密过滤器可对药液中0.5—5.0μm以上的微粒清除率大于90%，空气过滤器对空气中0.5μm以上微粒的滤除率大于90%' },
            { en: 'The same as the ordinary infusion device.', cn: '与普通输液器相同' },
            { en: 'The advantages of metal puncture device and plastic-steel composite puncture device', cn: '金属穿刺器和塑刚复合穿刺器的优点' },
            { en: 'Investigation and study: The necessity of precise filtration infusion', cn: '调查研究：精密过滤输液的必要性' },
            { en: 'The generation of particulates in liquid medicine（category, production process）', cn: '药液中微粒的产生（类别、生产过程）' },
            { en: 'The harm of particles to human body', cn: '微粒对人体的危害' },
            { en: 'The generation of transfusion reaction', cn: '输液反应的产生' },
            { en: 'Prevention and elimination of particulates', cn: '微粒的预防与消除' },
            { en: 'The pore size of the filter membrane is 20 microns, and the capillary diameter of human microcirculation is only 3-5microns', cn: '其滤过膜孔径为20μm，人体微循环毛细血管直径仅3—5μm' }
          ],
          images: [{ type: 'image', src: ImageProductT2P3Img1 }]
        },
        {
          name: { en: 'Disposable Abdominal Dialysis Drainage Bag', cn: '一次性使用腹透引流袋' },
          introduction: [
            { en: 'Design of protective cap pull ring, easy to operate', cn: '保护帽拉环设计，操作更方便简单' },
            { en: 'Medical grade PVC elastic pipeline, anti-kink', cn: '采用医用级PVC弹性管路，抗扭结' },
            { en: 'Transparent observation window designed bag for easy observation of dialysate color', cn: '透明观察窗设计的袋体，方便观察透析液颜色' },
            { en: 'The design of strengthening and thickening the bag body is not easy to cause leakage', cn: '袋体加厚加固设计，不易产生漏液' },
            { en: 'Design with suspension holes for easy fixing', cn: '带悬挂孔设计，方便固定' }
          ],
          images: [{ type: 'image', src: ImageProductT2P4Img1 }]
        }
      ]
    },
    {
      title: { en: 'Others', cn: '其他类' },
      image: ImageProductTab3,
      icon: IconViewProduct,
      content: [
        {
          name: { en: 'Disposable Arteriovenous Puncture Device', cn: '一次性使用动静脉穿刺器' },
          introduction: [
            { en: 'The needle tip is sharp and easy to puncture, and there is a back hole at the needle tip to increase blood flow', cn: '针尖锋利易于穿刺，针尖部位开有背孔，增大流血量' },
            { en: 'The concave-convex lock buckle designed on the pin wing is convenient for finger pinching to control the puncture angle and strength', cn: '针翼上防滑设计的凹凸锁扣，便于手指捏紧控制穿刺角度和力度' },
            { en: 'Easy-to-operate clamp can quickly block blood flow. Threaded interface is widely use din existing hemodialysis pipelines.', cn: '易于操作的夹子可迅速阻断血流，螺纹接口通用于现有血液透析管路' },
            { en: 'Blunt needle（suitable for buttonhole puncture）can effectively alleviate pain, reduce the incidence of thrombosis and hemangioma ,and effectively protect internal fistula.', cn: '钝型针（使用扣眼穿刺），有效减轻患者疼痛感，降低血栓、血管瘤发生率，有效保护内瘘' }
          ],
          images: [{ type: 'image', src: ImageProductT3P1Img1 }]
        },
        {
          name: { en: 'Disposable Hemodialysis Pipeline', cn: '一次性使用血液透析管路' },
          introduction: [
            { en: 'Medical grade PVC materials, ethylene oxide sterilization, sterile, pyrogen-free', cn: '医用级PVC材料，环氧乙烷灭菌，无菌，无热原' },
            { en: 'Smooth inner wall can effectively reduce blood flow resistance, coagulation and bubbles.', cn: '光滑内壁可有效降低血液阻力，减少凝血及气泡' },
            { en: 'Excellent elasticity of tube wall ,no knot, not easy to be compressed and deformed to affect blood flow', cn: '管壁弹性好，不打结，不易受压变形而影响血液流动' },
            { en: 'Protective wing at blood collection and medication mouth to prevent needle from puncturing by mistake..', cn: '采血和加药口处带保护翼，防针误刺' },
            { en: 'With pre-flushing pipeline and waste liquid bag accessories, easy to use.', cn: '带预冲管路、废液袋配件，使用方便' }
          ],
          images: [{ type: 'image', src: ImageProductT3P2Img1 }]
        },
        {
          name: { en: 'Multiple-layer PP Co-extrusion Film', cn: '多层PP共挤膜' },
          introduction: [
            { en: 'High clarity and super softness', cn: '高透明、超柔软' },
            { en: 'SFDA registration No.20020151', cn: '药监局注册号：20020151' }
          ],
          images: [{ type: 'image', src: ImageProductT3P3Img1 }]
        }
      ]
    }
  ]
}

export default PRODUCTCONFIG